import React from 'react';
import './HeroSection.css';
import heroHomeImg from '../../../assets/Hero-Home.jpeg';


const HeroSection: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="iframe-wrapper">
        <iframe 
          frameBorder="0" 
          allow="autoplay; encrypted-media;" 
          title="Villas Flamingos Promoción" 
          src="https://www.youtube.com/embed/HjZe-os3DIo?autoplay=1&controls=0&loop=1&playlist=HjZe-os3DIo&mute=1&rel=0&modestbranding=1">
        </iframe>
      </div>
      <img 
        src={heroHomeImg} 
        alt="hero-home" 
        className="hero-mobile-img" 
      />

      <div className="hero-content">
        
      </div>
    </section>
  );
};

export default HeroSection;